import { createAction } from '@reduxjs/toolkit';
import { ManufacturerAccountDetailsFormData } from 'src/components/pages/ManufacturerAccountDetails/ManufacturerAccountDetailsForm/ManufacturerAccountDetailsForm';
import {
  ApiPaginationResponse,
  TableQueryParameters,
} from 'src/components/ui/Table/Table.interface';

import { ManufacturerAccount } from '../models/ManufacturerAccount';

export const MANUFACTURER_ACCOUNT_SLICE = 'manufacturerAccount';

/* Get manufacturer account list */
export const getManufacturerAccountList = createAction<{
  params: TableQueryParameters<void, ManufacturerAccount>;
}>(`${MANUFACTURER_ACCOUNT_SLICE}/getManufacturerAccountList`);

/* Set manufacturer account list */
export const setManufacturerAccountList = createAction<
  ApiPaginationResponse<ManufacturerAccount[]>
>(`${MANUFACTURER_ACCOUNT_SLICE}/setManufacturerAccountList`);

/* Get manufacturer account details */
export const getManufacturerAccountDetails = createAction<{
  manId: string;
}>(`${MANUFACTURER_ACCOUNT_SLICE}/getManufacturerAccountDetails`);

/* Set manufacturer account details */
export const setManufacturerAccountDetails = createAction<ManufacturerAccount>(
  `${MANUFACTURER_ACCOUNT_SLICE}/setManufacturerAccountDetails`
);

/* Add manufacturer account */
export const addManufacturerAccount =
  createAction<ManufacturerAccountDetailsFormData>(
    `${MANUFACTURER_ACCOUNT_SLICE}/addManufacturerAccount`
  );

/* Edit manufacturer account */
export const editManufacturerAccount = createAction<
  ManufacturerAccountDetailsFormData & { eMail: string }
>(`${MANUFACTURER_ACCOUNT_SLICE}/editManufacturerAccount`);

/* Change manufacturer account status */
export const changeManufacturerAccountStatus = createAction<{
  manufacturer: ManufacturerAccount;
  enabled: boolean;
}>(`${MANUFACTURER_ACCOUNT_SLICE}/changeManufacturerAccountStatus`);

export const setManufacturerAccountStatus = createAction<{
  manufacturer: ManufacturerAccount;
  enabled: boolean;
}>(`${MANUFACTURER_ACCOUNT_SLICE}/setManufacturerAccountStatus`);

/* Remove manufacturer account */
export const removeManufacturerAccount =
  createAction<ManufacturerAccountDetailsFormData>(
    `${MANUFACTURER_ACCOUNT_SLICE}/removeManufacturerAccount`
  );

/* Edit manufacturer account email */
export const editManufacturerAccountEmail = createAction<{ eMail: string }>(
  `${MANUFACTURER_ACCOUNT_SLICE}/editManufacturerAccountEmail`
);
